import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { TRANSLATIONS } from "@/data/content";

const SUPPORTED_LANGS = new Set(["ro", "en", "ua"]);

const I18nContext = createContext({ lang: "ro", setLang: () => {}, t: (k) => k, dict: TRANSLATIONS.ro });

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "ro";
    const savedLang = localStorage.getItem("maxfit:lang") || "ro";
    return SUPPORTED_LANGS.has(savedLang) ? savedLang : "ro";
  });

  const setLang = (l) => {
    const nextLang = SUPPORTED_LANGS.has(l) ? l : "ro";
    setLangState(nextLang);
    try { localStorage.setItem("maxfit:lang", nextLang); } catch (e) { /* ignore */ }
  };

  useEffect(() => {
    document.documentElement.lang = lang === "ua" ? "uk" : lang;
  }, [lang]);

  const dict = TRANSLATIONS[lang] || TRANSLATIONS.ro;

  const t = useMemo(() => {
    return (path, fallback) => {
      const parts = path.split(".");
      let cur = dict;
      for (const p of parts) {
        if (cur == null) return fallback ?? path;
        cur = cur[p];
      }
      return cur ?? fallback ?? path;
    };
  }, [dict]);

  const value = useMemo(() => ({ lang, setLang, t, dict }), [lang, dict, t]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
